import { useEffect, useState } from "react";

export function useCountry() {
  const [state, setState] = useState({
    countryName: 'Nigeria',
    currency: 'ngn',
    country: 'ng',
  });


  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const response = await fetch('https://ipapi.co/json/');

  //       console.log(response, 'ANOTHER RESPONSE');
  //     } catch (error) {

  //     }
  //   };
  //   fetchData();
  // }, []);

  useEffect(() => {
    fetch("https://ipapi.co/json/")
      .then((response) => response.json())
      .then((data) => setState({
        countryName: data.country_name,
        currency: String(data.currency).toLowerCase(),
        country: data.country_code?.toLowerCase(),
      }))
      .catch((error) => setState({
        countryName: 'Nigeria',
        currency: 'ngn',
        country: 'ng',
      }));
  }, []);

  return state;
}

interface UserLocation {
  country: string;
  city?: string;
}

export function getUserLocationFromTimezone(): UserLocation {
  const timezone: string = Intl.DateTimeFormat().resolvedOptions().timeZone;
  console.log(timezone, 'TIME ZONE');
  const parts: string[] = timezone.split('/');
  const country: string = parts[0];
  const city: string | undefined = parts[1]?.replace(/_/g, ' ');

  return {
    country,
    city
  };
}




